import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";
import FormAdjust from "../Warehouse/TreasuryDocuments/FormAdjust";
import { getDataWithComp, getAlert, getMaxAdjNo } from "../../../utils/SamuiUtils";

const BACK_URL = "/stock/stock-documents";

export default function StockFormAdjustPage() {
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [maxDocNo, setMaxDocNo] = useState();
  useEffect(() => {
    localStorage.setItem("TreasuryDocumentsOrigin", BACK_URL);
    loadMaxNo();
  }, []);

  const loadMaxNo = async () => {
    try {
      const rows = await getDataWithComp(
        "WHDoc_H",
        `AND WHDoc_Type = '1' ORDER BY WHDoc_No DESC`
      );
      setMaxDocNo(getMaxAdjNo(rows));
    } catch (err) {
      getAlert("FAILED", err.message);
    }
  };

  const breadcrumbs = [
    { label: "สต๊อกสินค้า", link: "/stock/stock-overview" },
    { label: "เอกสารงานคลัง", link: BACK_URL },
    { label: "สร้างใบปรับปรุงสินค้า" },
  ];

  return (
    <div className="WarehouseStock TreasuryDocuments">
      <button
        onClick={() => setIsSidebarOpen(!isSidebarOpen)}
        className="btn btn-toggle-sidebar"
        style={{
          position: "fixed",
          top: "1rem",
          left: isSidebarOpen ? "190px" : "-15px",
          zIndex: 1001,
          background: "transparent",
          border: "none",
          color: "#E13F57",
          fontSize: "20px",
        }}
      >
        {isSidebarOpen ? "✖" : "☰"}
      </button>
      <div className="wrapper">
        <Sidebar isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} />
        <div
          className={`main-panel ${isSidebarOpen ? "sidebar-open" : "sidebar-closed"}`}
          style={{ height: "100vh", overflow: "hidden" }}
        >
          <Topbar breadcrumbs={breadcrumbs} />
          <div className="container">
            <div className="page-inner" style={{ marginTop: "8px" }}>
              <FormAdjust
                callInitialize={() => navigate(BACK_URL)}
                mode="FA"
                name="ใบปรับปรุงสินค้า"
                whDocNo={maxDocNo}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
